import axios from "axios";

// Backend origin, e.g. "https://pgciviladmissions.eng.pdn.ac.lk". Leave REACT_APP_API_HOST
// empty to call the same origin the app is served from (reverse proxy routes /api/ to the backend).
export const API_URL = (process.env.REACT_APP_API_HOST || "").replace(/\/+$/, "");

export const GRAPHQL_ENDPOINT = API_URL + "/api/graphql";

// "/" keeps the relative api/... paths below rooted at the origin, not the current page
axios.defaults.baseURL = API_URL || "/";

export const API_GET_REPORTS_APPLICANTS = `api/reports/applicants`;
export const API_GET_REPORTS_INTERVIEWS = `api/reports/interviews`;
export const API_GET_DOWNLOAD_APPLICATION = `api/application/download`;
export const API_GET_DOWNLOAD_APPLICATION_ZIP = `api/application/downloadPackage`;

export const setAxiosAuth = (token) => {
  axios.defaults.headers.common["Authorization"] = token
    ? `Bearer ${token}`
    : "";
};
